import Axios from "../../Config/API";
import {
    IEmailContaGrupo,
    IEmailContaGrupoVinculo,
} from "../../../Interfaces/Geral/Grupos/GruposEmailsInterfaces";
import { IEmailConta } from "../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";
import Service from "../../Service";

export async function DesvincularEmailContaGrupoService(
    IDEmailContaGrupo: number
) {
    return Service(
        Axios.delete(
            `/home/emailcontagrupo/deletaremailcontagrupo?idEmailContaGrupo=${IDEmailContaGrupo}`
        )
    );
}

export async function VincularEmailContaGrupoService(
    requestBody: IEmailContaGrupoVinculo
) {
    return Service(
        Axios.post(
            `/home/emailcontagrupo/cadastraremailcontagrupo`,
            requestBody
        )
    );
}

export async function ListarEmailContaVinculadosPorGrupoService(
    IDGrupo: number
) {
    return Service(
        Axios.get<Array<IEmailContaGrupo>>(
            `/home/emailcontagrupo/listaremailcontagrupovinculados?idGrupo=${IDGrupo}`
        )
    );
}

export async function ListarEmailContaNaoVinculadosPorGrupoService(
    IDGrupo: number
) {
    return Service(
        Axios.get<Array<IEmailConta>>(
            `/home/emailcontagrupo/listaremailcontagrupodesvinculados?idGrupo=${IDGrupo}`
        )
    );
}

export async function ListarEmailContaPorUsuarioService() {
    return Service(
        Axios.get<Array<IEmailConta>>(
            `/home/emailcontagrupo/listaremailcontaporusuario`
        )
    );
}
